<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <div
      class="align-items-center"
      style="padding:0.7%"
    >
      <b-input-group class="input-group-merge">
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-tooltip.hover.top="titleFormatoParcela"
          target="_blank"
          :href="`${publicPathParcela}FORMATOS/FORMATOSPARCELA.rar`"
          variant="outline-primary"
          class="btn-icon"
          style="margin-right: 5px;height: 30px;"
        >
          <feather-icon icon="DownloadIcon" />
        </b-button>
        <label
          v-b-tooltip.hover.top="titleImportarParcela"
          for="file"
          class="btn btn-outline-success"
          style="padding:1%"
        >
          <feather-icon
            icon="FileTextIcon"
            class="mr-50"
          />
          <span
            v-show="isBusyImport===true"
          >
            Cargando...
          </span>
          <span
            v-show="isBusyImport===false"
          >
            Importar
          </span>
        </label>
        <input
          v-show="false"
          id="file"
          type="file"
          @change="onChange"
        >
      </b-input-group>
    </div>
    <div
      class="body-content-overlay"
      :class="{'show': mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar = false"
    />
    <!-- SECCIÓN DE IMPORTACIÓN -->
    <!-- SECCIÓN DE IMPORTACIÓN -->
    <!-- Init Selection Ficha -->
    <div
      v-if="activeParcela === null"
      class="start-chat-area"
    >
      <div class="mb-1 start-chat-icon">
        <feather-icon
          icon="ClipboardIcon"
          size="56"
        />
      </div>
      <h4
        class="sidebar-toggle start-chat-text"
        @click="mqShallShowLeftSidebar = true"
      >
        Seleccione Encuestados para ver Parcelas
      </h4>
    </div>

    <!-- Email List -->
    <div
      v-else
      class="email-app-list"
    >

      <!-- App Searchbar Header -->
      <div class="app-fixed-search d-flex align-items-center">
        <!-- Toggler -->
        <div class="sidebar-toggle d-block d-lg-none ml-1">
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="cursor-pointer"
            @click="mqShallShowLeftSidebar = true"
          />
        </div>

        <!-- Searchbar -->
        <div class="d-flex align-content-center justify-content-between w-100">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon
                icon="SearchIcon"
                class="text-muted"
              />
            </b-input-group-prepend>
            <b-form-input
              v-model="searchFichaDet"
              placeholder="Buscar parcela por descripción..."
              @keyup.enter.native="fetchDetalle"
            />
          </b-input-group>
        </div>
      </div>

      <!-- App Action Bar -->
      <!-- Emails List -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="email-user-list scroll-area"
      >
        <div
          v-if="isBusyParcelaDet"
          class="text-center text-primary my-2"
        >
          <b-spinner
            variant="primary"
            class="align-middle"
          />
          <strong class="ml-1">Cargando...</strong>
        </div>
        <div v-else>
          <ul class="email-media-list">
            <b-media
              v-for="email in detallereclutamiento"
              :key="email.idParcela"
              tag="li"
              no-body
              :class="{ 'mail-read': email.isRead }"
              @click="updateEmailViewData(email)"
            >

              <b-media-aside class="media-left mr-50">
                <b-avatar
                  v-if="email.foto === ''"
                  class="avatar"
                  size="40"
                  variant="primary"
                  :src="require('@/assets/images/encuesta/parcela1.png')"
                />
                <b-avatar
                  v-else
                  class="avatar"
                  size="40"
                  variant="primary"
                  :src="`data:image/jpeg;base64,${email.foto}`"
                />
                <!-- <div class="user-action">
                  <b-form-checkbox
                    :checked="selectedEmails.includes(email.idParcela)"
                    @change="toggleSelectedMail(email.idParcela)"
                    @click.native.stop
                  />
                  <div class="email-favorite">
                    <feather-icon
                      icon="StarIcon"
                      size="17"
                      :class="{ 'text-warning fill-current': email.isStarred }"
                    />
                  </div>
                </div> -->
              </b-media-aside>

              <b-media-body>
                <div class="mail-details">
                  <div class="mail-items">
                    <h5 class="mb-25">
                      {{ email.ubigeoAll.dpto + ' - ' + email.ubigeoAll.prov + ' - ' + email.ubigeoAll.dist }}
                    </h5>
                    <span class="text-truncate">Descripción {{ email.descripcion }}</span>
                  </div>
                  <div class="mail-meta-item">
                    <span
                      v-for="label in email.labels"
                      :key="label"
                      class="mx-50 bullet bullet-sm"
                      :class="`bullet-${resolveLabelColor(label)}`"
                    />
                    <span class="mail-date">Area: {{ email.area }}</span>
                    <!-- <b-dropdown
                      variant="link"
                      no-caret
                      toggle-class="p-0"
                      right
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="18"
                          class="text-body cursor-pointer"
                        />
                      </template>
                      <b-dropdown-item>
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">Editar</span>
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">Eliminar</span>
                      </b-dropdown-item>
                    </b-dropdown> -->
                  </div>
                </div>

                <b-badge
                  v-if="email.salioOrigen"
                  v-b-tooltip.hover.top="getDateFmt(email.salioOrigenFecha)"
                  variant="light-primary"
                >
                  SALIÓ
                </b-badge>

                <b-badge
                  v-if="email.llegoDestino"
                  v-b-tooltip.hover.top="getDateFmt(email.llegoDestinoFecha)"
                  variant="light-secondary"
                  class="ml-1"
                >
                  LLEGÓ
                </b-badge>

                <b-badge
                  v-if="email.entroPlantacion"
                  v-b-tooltip.hover.top="getDateFmt(email.entroPlantacionFecha)"
                  variant="light-success"
                  class="ml-1"
                >
                  ENTRÓ PLANTACIÓN
                </b-badge>

                <b-badge
                  v-if="email.encuestado"
                  v-b-tooltip.hover.top="getDateFmt(email.encuestadoFecha)"
                  variant="light-warning"
                  class="ml-1"
                >
                  ENCUESTADO
                </b-badge>

                <b-badge
                  v-if="email.seguridadVb"
                  v-b-tooltip.hover.top="getDateFmt(email.seguridadVbFecha)"
                  variant="light-info"
                  class="ml-1"
                >
                  VB SEGURIDAD
                </b-badge>

                <b-badge
                  v-if="email.topicoVb"
                  v-b-tooltip.hover.top="getDateFmt(email.topicoVbFecha)"
                  variant="light-danger"
                  class="ml-1"
                >
                  VB TÓPICO
                </b-badge>

                <b-badge
                  v-if="email.induccion"
                  v-b-tooltip.hover.top="getDateFmt(email.induccionFecha)"
                  variant="light-dark"
                  class="ml-1"
                >
                  INDUCCIÓN
                </b-badge>

                <div
                  v-if="email.observaciones"
                  class="mail-message"
                >
                  <p class="text-truncate mb-0">
                    Observación: {{ email.observaciones }}
                  </p>
                </div>
              </b-media-body>
            </b-media>
          </ul>
          <div
            class="no-results"
            :class="{'show': !detallereclutamiento.length}"
          >
            <h5>No se encontraron resultados</h5>
          </div>
        </div>
      </vue-perfect-scrollbar>
    </div>

    <!-- Email View/Detail -->
    <email-view
      ref="refEmailView"
      :class="{'show': showEmailDetails}"
      :email-view-data="emailViewData"
      :opended-email-meta="opendedEmailMeta"
      :map-enabled="mapEnabled"
      @close-email-view="showEmailDetails = mapEnabled= false"
      @move-email-to-folder="moveOpenEmailToFolder"
      @toggle-email-starred="toggleStarred(emailViewData)"
      @update-email-label="updateOpenEmailLabel"
      @mark-email-unread="markOpenEmailAsUnread"
      @change-opened-email="changeOpenedEmail"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <ficha-sidebar
        ref="refFichaSidebar"
        :class="{'show': mqShallShowLeftSidebar}"
        :active-encuestado-id="activeParcela ? activeParcela : null"
        @open-modal-ficha="openModalFicha"
        @open-modal-edit-ficha="openModalEditFicha"
        @delete-ficha="deleteFicha"
        @close-left-sidebar="mqShallShowLeftSidebar = false"
        @open-ficha="openFichaDet"
      />
    </portal>

    <!-- Form New/Edit Ficha -->
    <b-modal
      v-model="modalShow"
      :title="titleModal"
      ok-title="Guardar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyFicha"
      @ok="okMdlFicha"
    >
      <b-overlay
        :show="isBusyFicha"
        rounded="sm"
      >
        <ficha-form
          ref="refFichaForm"
          :is-busy-ficha.sync="isBusyFicha"
          :modal-show.sync="modalShow"
          :type-action="typeAction"
          :data-edit="dataEditF"
          @refetch-data="refetchDataFicha"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>

    <!-- Form New/Edit Ficha Detalle -->
    <b-modal
      v-model="modalShowDet"
      :title="titleModalDet"
      ok-title="Guardar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      :busy="isBusyFicha"
      @ok="okMdlFichaDet"
    >
      <b-overlay
        :show="isBusyFicha"
        rounded="sm"
      >
        <ficha-detalle-form
          ref="refFichaFormDet"
          :is-busy-ficha.sync="isBusyFicha"
          :modal-show.sync="modalShowDet"
          :type-action="typeActionDet"
          :active-ficha-id="activeParcela ? activeParcela : null"
          @refetch-data="fetchDetalle"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import {
  ref, computed,
  // ref, watch, computed, onUnmounted,
} from '@vue/composition-api'
import {
  BBadge, BFormInput, BInputGroup, BInputGroupPrepend,
  BMedia, BMediaAside, BMediaBody, BModal, BAvatar, BOverlay, VBTooltip, BSpinner, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { filterTags, formatDateToMonthShort } from '@core/utils/filter'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import moment from 'moment'
import XLSX from 'xlsx'
import { _ } from 'vue-underscore'
import Ripple from 'vue-ripple-directive'
import { useNotify } from '@/helpers/toast'
import EmailView from './EmailView.vue'
import FichaSidebar from './FichaSidebar.vue'
import FichaForm from './FichaForm.vue'
import FichaDetalleForm from './FichaDetalleForm.vue'

export default {
  components: {
    BBadge,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BMedia,
    BMediaAside,
    BMediaBody,
    BModal,
    BAvatar,
    BOverlay,
    BButton,
    BSpinner,

    // 3rd Party
    VuePerfectScrollbar,

    // App SFC
    EmailView,

    FichaSidebar,
    FichaForm,
    FichaDetalleForm,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const modalShow = ref(false)
    const modalShowDet = ref(false)
    const typeAction = ref('new')
    const typeActionDet = ref('new')
    // Constants of Ficha
    const refFichaSidebar = ref(null)
    const refFichaForm = ref(null)
    const refFichaFormDet = ref(null)
    const titleModal = ref('Nueva Ficha de Reclutamiento')
    const titleModalDet = ref('Nuevo Reclutamiento')
    const isBusyFicha = ref(false)
    const isBusyParcelaDet = ref(false)
    const activeParcela = ref(null)
    // Emails & EmailsMeta
    const detallereclutamiento = ref([])
    const emails = ref([])
    const emailsMeta = ref({})
    const searchFichaDet = ref('')
    const dataEditF = ref({})
    const opClick = ref('')
    const refEmailView = ref(null)
    /* ddd */
    const items = ref([])
    const paths = ref([])
    const latitude = ref(-6.0220945)
    const longitude = ref(-6.0220945)
    const title = ref('Título de Marcador')
    const dataParcela = ref({})
    const mapEnabled = ref(false)
    const dataImport = ref([])
    const isBusyImport = ref(false)
    const publicPathParcela = ref(process.env.BASE_URL)
    const showEmailDetails = ref(false)
    const titleFormatoParcela = ref('Formato para subir datos de parcela')
    const titleImportarParcela = ref('Importar parcela en formato Excel')
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    const openModalFicha = () => {
      typeAction.value = 'new'
      titleModal.value = 'Nueva Ficha de Reclutamiento'
      modalShow.value = true
    }

    const openModalEditFicha = (dataFicha, op) => {
      opClick.value = op
      if (dataFicha.etapa === 1) {
        typeAction.value = 'edit'
        titleModal.value = 'Editar Ficha de Reclutamiento'
        dataEditF.value = dataFicha
        modalShow.value = true
      } else {
        notify('Ha ocurrido un error', 'No se pueden editar fichas finalizados o inactivas.', 'danger')
      }
    }

    const deleteFicha = (dataFicha, op) => {
      opClick.value = op
      Vue.swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('reclutamiento/FICHA_DELETE', {
              id: dataFicha.idFichaReclutamiento,
            })
            .then(() => {
              notify('Operación Exitosa', 'El proceso se ha ejecutado satisfactoriamente.', 'success')
              refFichaSidebar.value.getFichas()
            })
            .catch(error => {
              let errorMessage = 'Intentelo en otro momento.'
              if (error.response) {
                errorMessage = error.response.data.message
              }
              notify('Ha ocurrido un error', errorMessage, 'danger')
            })
        }
      })
    }

    const openModalImportCoordenadas = () => {
      if (typeActionDet.value === 'new') {
        titleModalDet.value = `Nuevo Reclutamiento en Ficha ${activeParcela.value}`
      } else {
        titleModalDet.value = 'Editar Reclutamiento'
      }
      isBusyFicha.value = false
      modalShowDet.value = true
    }

    const okMdlFicha = ev => {
      isBusyFicha.value = true
      ev.preventDefault()
      refFichaForm.value.saveForm()
    }

    const okMdlFichaDet = ev => {
      isBusyFicha.value = true
      ev.preventDefault()
      refFichaFormDet.value.saveForm()
    }

    // Detalle Reclutamiento
    const fetchDetalle = () => {
      store.dispatch('gsencuesta/PARCELA_FIND_ALL', {
        limit: 20,
        page: 1,
        sortBy: 'idParcela%7CDESC',
        query: searchFichaDet.value,
        seccion: 'BENEFICIARIO',
        idSeccion: activeParcela.value,
      })
        .then(response => {
          detallereclutamiento.value = response.items
          isBusyParcelaDet.value = false
          // refFichaSidebar.value.updateCantFichas(activeParcela.value, detallereclutamiento.value.length)
        })
    }

    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()

    const openFichaDet = fichaId => {
      if (opClick.value === '') {
        isBusyParcelaDet.value = true
        activeParcela.value = fichaId
        fetchDetalle()
        mqShallShowLeftSidebar.value = false
        showEmailDetails.value = false
      }
      opClick.value = ''
    }
    // ------------------------------------------------
    // Mail Selection
    // ------------------------------------------------
    const selectedEmails = ref([])
    const toggleSelectedMail = mailId => {
      const mailIndex = selectedEmails.value.indexOf(mailId)

      if (mailIndex === -1) selectedEmails.value.push(mailId)
      else selectedEmails.value.splice(mailIndex, 1)
    }
    const selectAllEmailCheckbox = computed(() => detallereclutamiento.value.length && (detallereclutamiento.value.length === selectedEmails.value.length))
    const isSelectAllEmailCheckboxIndeterminate = computed(() => Boolean(selectedEmails.value.length) && detallereclutamiento.value.length !== selectedEmails.value.length)
    const selectAllCheckboxUpdate = val => {
      selectedEmails.value = val ? detallereclutamiento.value.map(mail => mail.idParcela) : []
    }
    // ? Watcher to reset selectedEmails is somewhere below due to watch dependecy fullfilment

    // ------------------------------------------------
    // Mail Actions
    // ------------------------------------------------
    const toggleStarred = email => {
      store.dispatch('app-email/updateEmail', {
        emailIds: [email.id],
        dataToUpdate: { isStarred: !email.isStarred },
      }).then(() => {
        // eslint-disable-next-line no-param-reassign
        email.isStarred = !email.isStarred
      })
    }
    const loadState = () => {
      const mut0 = {
        oper: 'list',
        data: {},
      }
      store.commit('gsencuesta/OPERACION_PARCELA', mut0)
    }
    const updateState = data => {
      const mut = {
        oper: 'show',
        data,
      }
      store.commit('gsencuesta/OPERACION_PARCELA', mut)
    }
    const setVistoBueno = type => {
      store.dispatch('reclutamiento/DETALLE_VISTO_BUENO', {
        ids: selectedEmails.value,
        etapa: type,
      })
        .then(() => { fetchDetalle() })
        .finally(() => { selectedEmails.value = [] })
    }

    // ------------------------------------------------
    // Email Details
    // ------------------------------------------------
    const emailViewData = ref({})
    const opendedEmailMeta = computed(() => {
      const openedEmailIndex = detallereclutamiento.value.findIndex(e => e.idParcela === emailViewData.value.id)
      return {
        hasNextEmail: Boolean(detallereclutamiento.value[openedEmailIndex + 1]),
        hasPreviousEmail: Boolean(detallereclutamiento.value[openedEmailIndex - 1]),
      }
    })
    const updateEmailViewData = async email => {
      loadState()
      if (!email.isRead && (email.folder === 'inbox' || email.folder === 'spam')) {
        emailsMeta.value[email.folder] -= 1
      }
      // email.isRead = true
      emailViewData.value = email
      showEmailDetails.value = true
      mapEnabled.value = true
      updateState(emailViewData.value)
      // await refEmailView.value.loadStatus(mapEnabled.value, emailViewData.value)
      // Mark email is read
      /* store.dispatch('app-email/updateEmail', {
        emailIds: [email.id],
        dataToUpdate: { isRead: true },
      })
        .then(() => {
          // If opened email is unread then decrease badge count for email meta based on email folder
          if (!email.isRead && (email.folder === 'inbox' || email.folder === 'spam')) {
            emailsMeta.value[email.folder] -= 1
          }

          // eslint-disable-next-line no-param-reassign
          email.isRead = true
        })
        .finally(() => {
          emailViewData.value = email
          showEmailDetails.value = true
        }) */
    }
    const moveOpenEmailToFolder = () => {
      selectedEmails.value = [emailViewData.value.id]
      selectedEmails.value = []
      showEmailDetails.value = false
    }
    const updateOpenEmailLabel = label => {
      selectedEmails.value = [emailViewData.value.id]

      // Update label in opened email
      const labelIndex = emailViewData.value.labels.indexOf(label)
      if (labelIndex === -1) emailViewData.value.labels.push(label)
      else emailViewData.value.labels.splice(labelIndex, 1)

      selectedEmails.value = []
    }

    const markOpenEmailAsUnread = () => {
      selectedEmails.value = [emailViewData.value.id]

      selectedEmails.value = []
      showEmailDetails.value = false
    }

    const changeOpenedEmail = dir => {
      const openedEmailIndex = detallereclutamiento.value.findIndex(e => e.id === emailViewData.value.id)
      const newEmailIndex = dir === 'previous' ? openedEmailIndex - 1 : openedEmailIndex + 1
      emailViewData.value = detallereclutamiento.value[newEmailIndex]
    }
    const saveData = data => {
      if (_.isUndefined(data[0].beneficiario)) {
        isBusyImport.value = false
        notify('Ha ocurrido un error', 'El formato seleccionado es invalido.', 'danger')
      } else {
        store
          .dispatch('gsencuesta/PARCELA_CREATE_ALL', data)
          .then(response => {
            // fetchDetalle()
            isBusyImport.value = false
            notify('Operación Exitosa', 'Datos guardados correctamente', 'success')
            return response
          })
          .catch(error => {
            isBusyImport.value = false
            notify('Ha ocurrido un error', error.response.data.errorMessage, 'danger')
          })
      }
    }
    const viewPoints = event => {
      loadState()
      mapEnabled.value = false
      isBusyImport.value = true
      const file = event.target.files ? event.target.files[0] : null // files[0]
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          paths.value = []
          items.value = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            paths.value = []
            items.value = []
            if (roa.length > 0) {
              roa.forEach(dat => {
                const lat = _.isUndefined(dat.LATITUD) ? 0 : parseFloat(dat.LATITUD)
                const lng = _.isUndefined(dat.LONGITUD) ? 0 : parseFloat(dat.LONGITUD)
                paths.value.push({
                  latitud: lat,
                  longitud: lng,
                })
                items.value.push({
                  latitud: lat,
                  longitud: lng,
                })
              })
              dataParcela.value = {
                descripcion: 'Parcela Importada',
                parcelaCoordenada: paths.value,
              }
              mapEnabled.value = true
              emailViewData.value = dataParcela.value
              showEmailDetails.value = true
              isBusyImport.value = false
              // this.$refs.refEmailView.loadStatus(this.mapEnabled, this.emailViewData)
              // refEmailView.value.loadStatus(mapEnabled.value, emailViewData.value)
              updateState(emailViewData.value)
            }
          })
          document.getElementById('file').value = ''
        }
        fileReader.readAsArrayBuffer(file)
      }
    }
    const viewSavePoints = event => {
      mapEnabled.value = false
      isBusyImport.value = true
      const file = event.target.files ? event.target.files[0] : null
      let stateTabData = false
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          dataImport.value = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            // dataImport.value = []
            const arrayDetail = []
            let index = 0
            if (roa.length > 0) {
              if (y === 'DATA') {
                stateTabData = true
                roa.forEach(dat => {
                  if (_.contains(arrayDetail, dat.BENEFICIARIO_DNI)) {
                    const filtered = _.findWhere(dataImport.value, { dni: dat.BENEFICIARIO_DNI })
                    dataImport.value[filtered.index].parcelaCoordenada.push({
                      latitud: dat.LATITUD,
                      longitud: dat.LONGITUD,
                      orden: dat.ORDEN,
                    })
                  } else {
                    dataImport.value.push({
                      index,
                      beneficiario: dat.BENEFICIARIO,
                      ubigeo: dat.UBIGEO,
                      descripcion: dat.DESCRIPCION,
                      dni: dat.BENEFICIARIO_DNI,
                      foto: dat.BENEFICIARIO_DNI, // solucion temporal
                      area: Number(Number.parseFloat(dat.AREA).toFixed(2)),
                      parcelaCoordenada: [
                        {
                          latitud: dat.LATITUD,
                          longitud: dat.LONGITUD,
                          orden: dat.ORDEN,
                        },
                      ],
                    })
                    arrayDetail.push(dat.BENEFICIARIO_DNI)
                    index += 1
                  }
                })
              }
            }
          })
          document.getElementById('file').value = ''
          if (!stateTabData) {
            isBusyImport.value = false
            notify('Warning', 'En el formato excel, el tap de exportación debe ser de nombre DATA.', 'warning')
          } else {
            saveData(dataImport.value)
          }
          // saveData(dataImport.value)
        }
        fileReader.readAsArrayBuffer(file)
      }
    }
    const onChange = event => {
      Vue.swal({
        title: 'Está seguro?',
        text: 'Guardar: Se guardará en la base de datos. Visualizar: Solo se visualizará en el visor de mapa',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Visualizar',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          viewSavePoints(event)
        } else if (result.dismiss === 'cancel') {
          viewPoints(event)
        }
      })
    }
    return {
      // UI
      perfectScrollbarSettings,

      // Emails & EmailsMeta
      emails,
      emailsMeta,

      // Mail Selection
      selectAllEmailCheckbox,
      isSelectAllEmailCheckboxIndeterminate,
      selectedEmails,
      toggleSelectedMail,
      selectAllCheckboxUpdate,

      // Mail Actions
      toggleStarred,

      // Email Details
      showEmailDetails,
      emailViewData,
      opendedEmailMeta,
      updateEmailViewData,
      moveOpenEmailToFolder,
      updateOpenEmailLabel,
      markOpenEmailAsUnread,
      changeOpenedEmail,

      // UI Filters
      filterTags,
      formatDateToMonthShort,

      // Left Sidebar Responsiveness
      mqShallShowLeftSidebar,
      activeParcela,
      openFichaDet,
      openModalFicha,
      openModalImportCoordenadas,
      openModalEditFicha,
      deleteFicha,
      okMdlFicha,
      okMdlFichaDet,
      isBusyFicha,
      isBusyParcelaDet,
      modalShow,
      modalShowDet,
      typeAction,
      typeActionDet,
      titleModal,
      titleModalDet,
      refFichaSidebar,
      refFichaForm,
      refFichaFormDet,

      // Detalle
      detallereclutamiento,
      fetchDetalle,

      searchFichaDet,
      setVistoBueno,
      dataEditF,
      refEmailView,
      /* ex */
      onChange,
      items,
      paths,
      latitude,
      longitude,
      title,
      dataParcela,
      mapEnabled,
      dataImport,
      saveData,
      viewPoints,
      viewSavePoints,
      publicPathParcela,
      isBusyImport,
      titleFormatoParcela,
      titleImportarParcela,
      updateState,
    }
  },
  /* data: () => ({
    items: [],
    paths: [],
    latitude: -6.0220945,
    longitude: -76.9884157,
    title: 'Título de Marcador',
    dataParcela: {},
    mapEnabled: false,
    emailViewData: {},
    showEmailDetails: false,
    dataImport: [],
  }), */
  methods: {
    getDateFmt(fecha) {
      return moment(String(fecha)).format('DD/MM/YYYY HH:mm:ss')
    },
    refetchDataFicha(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.$refs.refFichaSidebar.getFichas()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.message
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    /* async onChange(event) {
      this.$swal({
        title: '¿Deseas guardar en la base de datos?',
        text: 'Si: Guardará en la base de datos. No: Sólo se viasualizará en google maps',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.viewSavePoints(event)
        } else if (result.dismiss === 'cancel') {
          this.viewPoints(event)
        }
      })
    }, */
    /* async viewPoints(event) {
      this.mapEnabled = false
      const file = event.target.files ? event.target.files[0] : null // files[0]
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          this.paths = []
          this.items = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            this.paths = []
            this.items = []
            if (roa.length > 0) {
              roa.forEach(dat => {
                const lat = _.isUndefined(dat.LATITUD) ? 0 : parseFloat(dat.LATITUD)
                const lng = _.isUndefined(dat.LONGITUD) ? 0 : parseFloat(dat.LONGITUD)
                this.paths.push({
                  latitud: lat,
                  longitud: lng,
                })
                this.items.push({
                  latitud: lat,
                  longitud: lng,
                })
              })
              this.dataParcela = {
                descripcion: 'Parcela Importada',
                parcelaCoordenada: this.paths,
              }
              this.mapEnabled = true
              this.emailViewData = this.dataParcela
              this.showEmailDetails = true
              this.$refs.refEmailView.loadStatus(this.mapEnabled, this.emailViewData)
            }
          })
        }
        fileReader.readAsArrayBuffer(file)
      }
    }, */
    /* async viewSavePoints(event) {
      this.mapEnabled = false
      const file = event.target.files ? event.target.files[0] : null // files[0]
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          this.dataImport = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            this.dataImport = []
            const arrayDetail = []
            let index = 0
            if (roa.length > 0) {
              roa.forEach(dat => {
                if (_.contains(arrayDetail, dat.BENEFICIARIO_DNI)) {
                  const filtered = _.findWhere(this.dataImport, { dni: dat.BENEFICIARIO_DNI })
                  this.dataImport[filtered.index].parcelaCoordenada.push({
                    latitud: dat.LATITUD,
                    longitud: dat.LONGITUD,
                    orden: dat.ORDEN,
                  })
                } else {
                  this.dataImport.push({
                    index,
                    beneficiario: dat.BENEFICIARIO,
                    ubigeo: dat.UBIGEO,
                    descripcion: dat.DESCRIPCION,
                    dni: dat.BENEFICIARIO_DNI,
                    foto: dat.BENEFICIARIO_DNI,
                    area: Number(Number.parseFloat(dat.AREA).toFixed(2)),
                    parcelaCoordenada: [
                      {
                        latitud: dat.LATITUD,
                        longitud: dat.LONGITUD,
                        orden: dat.ORDEN,
                      },
                    ],
                  })
                  arrayDetail.push(dat.BENEFICIARIO_DNI)
                  index += 1
                }
              })
            }
          })
          this.saveData(this.dataImport)
        }
        fileReader.readAsArrayBuffer(file)
      }
    }, */
    /* saveData(data) {
      if (_.isUndefined(data[0].beneficiario)) {
        this.$bvToast.toast('El formato seleccionado es invalido', {
          title: 'Ha ocurrido un error',
          variant: 'danger',
          solid: true,
        })
      } else {
        store
          .dispatch('gsencuesta/PARCELA_CREATE_ALL', data)
          .then(response => {
            this.$bvToast.toast('Datos guardados correctamente.', {
              title: 'Operación Exitosa',
              variant: 'success',
              solid: true,
            })
            // this.$router.push('app-cultivo-parcela')
            return response
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.errorMessage, {
              title: 'Ha ocurrido un error',
              variant: 'danger',
              solid: true,
            })
          })
      }
    }, */
  },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-ficha.scss";
</style>
